module.exports = __webpack_public_path__ + "static/lato-v16-latin-700-1efbd38aa76ddae2580fedf378276333.woff2";